import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { DropdownMenu } from '../DropdownMenu/DropdownMenu';
import { IDropdownMenuItem } from '../DropdownMenu/DropdownMenu.interface';
import { Loader } from '../Loader';
import { IWidgetHeaderButton, IWidgetHeaderButtonRender } from './WidgetHeader.interface';

export interface IWidgetHeaderProps {
  title: string | JSX.Element;
  headerButtons?: (IWidgetHeaderButtonRender | IWidgetHeaderButton)[];
  dropdownItems?: IDropdownMenuItem[];
  isLoading?: boolean;
}

const isRender = (button: IWidgetHeaderButtonRender | IWidgetHeaderButton): button is IWidgetHeaderButtonRender =>
  Object.hasOwn(button, 'render');

export const WidgetHeader = ({
  title,
  headerButtons,
  dropdownItems: dropdown,
  isLoading,
}: React.PropsWithChildren<IWidgetHeaderProps>): JSX.Element => {
  const renderButtons = () =>
    (headerButtons || []).map((button, i) => {
      if (isRender(button)) {
        return (
          <div key={i} className="ml-2">
            {button.render()}
          </div>
        );
      }
      return (
        <Button
          // TODO: кучу намешанных стилей без переопределения компонента
          // и вынесения собственной обертки невозможно переопределить легко иначе
          style={{ padding: '0.25rem 0.75rem', height: '1.75rem' }}
          className="ml-2"
          onClick={button.clickHandler}
          disabled={button.disabled}
          key={i}>
          {button.title}
        </Button>
      );
    });

  return (
    <Card.Header className="d-flex justify-content-between pl-5 pr-3 py-3 align-items-center">
      <div className="card-header-title text-nowrap font-weight-bold mr-2 py-0 text-big">{title}</div>
      <div className="d-flex">
        {isLoading ? (
          <Loader size="sm" />
        ) : (
          <>
            {headerButtons && renderButtons()}
            {dropdown && (
              <div className="ml-2">
                <DropdownMenu items={dropdown} />
              </div>
            )}
          </>
        )}
      </div>
    </Card.Header>
  );
};
